import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  card: {
    color: TextColors.light,

    '& $contentHeading': {
      color: TextColors.light,
    },
    '& $copy, $date': {
      color: hexToRGBA(TextColors.light, TextOpacities.light1),
    },
    '& $category': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  card: {
    color: TextColors.dark,

    '& $contentHeading': {
      color: TextColors.dark,
    },
    '& $copy, $date': {
      color: hexToRGBA(TextColors.dark, TextOpacities.light1),
    },
    '& $category': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    card: {
      '&.dark-theme': darkTheme.card,
      '&.light-theme': lightTheme.card,
      position: 'relative',
    },
    image: {
      '&.MuiCardMedia-root': {
        width: '100%',
      },
    },
    defaultImage: {
      height: '100%',
    },
    content: {
      '& .MuiCardContent-root': {
        padding: muiTheme.spacing(4),
      },
    },
    defaultContent: {
      '&.MuiCardContent-root': {
        padding: muiTheme.spacing(4),

        '&:last-of-type': {
          paddingBottom: muiTheme.spacing(4),
        },
      },

      [muiTheme.breakpoints.up('md')]: {
        '&.MuiCardContent-root': {
          padding: muiTheme.spacing(5),

          '&:last-of-type': {
            paddingBottom: muiTheme.spacing(5),
          },
        },
      },
    },
    columns: {
      '& .column': {
        justifyContent: 'center',
      },

      [muiTheme.breakpoints.down('sm')]: {
        '& .left-column': {
          paddingBottom: muiTheme.spacing(4),
        },
      },
    },
    defaultColumns: {
      '$card & .left-column:not(:last-child)': {
        paddingRight: 0,

        [muiTheme.breakpoints.down('sm')]: {
          marginBottom: 0,
        },
      },

      '$card & .right-column:not(:first-child)': {
        paddingLeft: 0,
      },
    },
    featuredContent: {
      '&.MuiCardContent-root': {
        padding: 0,

        '&:last-child': {
          paddingBottom: 0,
        },
      },
    },
    category: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(1),
      },
    },
    cardDescription: {
      '&:not(:last-child)': {
        marginBottom: muiTheme.spacing(4),
      },
    },
    contentHeading: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(1.5),
      },
    },
    date: {
      '&.MuiTypography-root': {
        '& p': {
          marginTop: 0,
          marginBottom: 0,

          '&:not(:first-child)': {
            marginTop: muiTheme.spacing(1),
          },
        },
      },
    },
    actions: {
      '&.MuiCardActions-root': {
        padding: 0,

        '& + .MuiTypography-caption': {
          marginTop: muiTheme.spacing(3),
        },
      },
    },
    divider: {
      padding: '0 8px',
    },
    cardMediaWrapper: {
      [muiTheme.breakpoints.up('xs')]: {
        padding: '0 !important',
      },
    },
    cardLink: {
      '&.MuiButtonBase-root': {
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 1,
        top: 0,
        left: 0,
      },
    },
    cardActionsLink: {
      '&.MuiButtonBase-root': {
        position: 'relative',
        zIndex: 2,
      },
    },
  }),
  { name: 'GenFeaturedContentColumnCard' },
);

export default useStyles;
